import React, { useState, } from 'react'
import { Box, Link, Paper } from '@mui/material'


import {celeste_5} from '../../assets/images/projects/celeste'
import {hive_1} from '../../assets/images/projects/hive'
import {jackson_3} from '../../assets/images/projects/jackson'
import {twc_2} from '../../assets/images/projects/the-new-chapter'
import {vine_10} from '../../assets/images/projects/vine'
import {waterfront_10} from '../../assets/images/projects/waterfront'
import {madrona_15} from '../../assets/images/projects/madrona'



const MyProjects = (sx) => {

    const [isHovered, setIsHovered] = useState(null);

    const handleMouseEnter = (index) => {
      if(!('ontouchstart' in window)) {
        setIsHovered(index);
      }
    }
  
    const handleMouseLeave = () => {
      setIsHovered(null);
    }
  
    const handleClick = () => {
      setIsHovered(!isHovered);
    }
  
    const projects = [
      {name: 'Celeste Residence', image: celeste_5, path: 'celeste-residence'},
      {name: 'Hive II', image: hive_1, path: 'hive'},
      {name: "Jackson's House", image: jackson_3, path: 'jackson-house'},
      {name: 'The New Chapter', image: twc_2, path: 'the-new-chapter'},
      {name: 'Vine', image: vine_10, path: 'vine'},
      {name: 'Waterfront Eye Wear', image: waterfront_10, path: 'waterfront-eye-wear'},
      {name: 'Madrona', image: madrona_15, path: 'madrona'},
    ]

  return (
    <>
    {projects.map((project, index) =>(
        <Box 
        key={index}
        sx={{          
          minWidth:'30rem',
          minHeight: '40rem',
          backgroundImage: `url(${project.image})`,
          backgroundRepeat:'no-repeat',
          backgroundSize:'cover',
          display: 'flex',
          flex: '0 0 auto',
          margin:'2rem 0',
          position:'relative',
          transition: 'background-color 0.5s ease-in-out',
          '@media (max-width: 768px)': {
            minWidth: '100%', // Adjust width for smaller screens
            minHeight: '40rem', // Remove fixed height for smaller screens
          },
          ...sx
        }}
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
        >
          <Paper
            onClick={() => window.location.href=`/projects/${project.path}`}
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              backgroundColor: isHovered === index ? 'rgba(255, 255, 255, 0.5)' : 'rgba(255, 255, 255, 0)' ,
              zIndex: 1,
            }}
          >
          <Link
            href={`/projects/${project.path}`}
            sx={{
              
              fontSize:'2rem',
              alignContent:'center',
              textAlign:'center',
              width:'100%',
              color: isHovered === index ? '#000000' : '#ffffff',
              textDecoration:'none',
              textTransform:'bolder',
              display: isHovered === index ? 'block' : '',
              transition: 'bottom 0.5s ease-in-out',
              position:'absolute',
              bottom: isHovered === index ? 'calc(50% - 1rem)' : '-50px',
              left: '0',
            }}
          >
            {project.name}
          </Link>
          </Paper>
        </Box>
      ))}
      </>
  )
}

export default MyProjects